import { animate, style, transition, trigger } from '@angular/animations';

export const FadeOut = trigger('fadeOut', [transition(':leave', [animate('0.5s ease-out', style({ opacity: 0 }))])]);

export const FadeInOut = trigger('fadeInOut', [
  transition(':enter', [style({ opacity: 0 }), animate('0.1s ease-in-out')]),
  transition(':leave', [animate('1s ease-in-out', style({ opacity: 0 }))]),
]);

export const Feedback = trigger('feedback', [
  transition(':enter', [style({ opacity: 0 }), animate('0.5s ease-in-out')]),
  transition(':leave', [animate('4s ease-in-out', style({ opacity: 0 }))]),
]);

export const FadeNavbar = trigger('fadeNavbar', [
  transition(':enter', [style({ opacity: 0 }), animate('350ms', style({ opacity: 1 }))]),
  transition(':leave', [style({ opacity: 1 }), animate('350ms', style({ opacity: 0 }))]),
]);
